module.exports = __webpack_public_path__ + "img/cross.fddf8015.png";